export default __webpack_public_path__ + "static/media/app_dev_logo.83b9853a.svg";